module.exports = __webpack_public_path__ + "img/mac1.2d21031a.png";